import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import DashboardHeader from './DashboardHeader';

const DashboardLayout = ({ children }) => {
  const location = useLocation();
  const [headerHeight, setHeaderHeight] = useState(60);

  useEffect(() => {
    const header = document.querySelector('header');
    if (header) {
      setHeaderHeight(header.offsetHeight);
    }
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <DashboardHeader />
      <div style={{ display: 'flex' }}>
        <Sidebar />
        <main
          style={{
            paddingTop: `${headerHeight + 16}px`,
            backgroundColor: '#f9f9f9',
            flexGrow: 1, // Allows the main content area to expand and fill available space
            width: '100%', // Ensures the main content stretches across the entire width
            boxSizing: 'border-box', // Ensures padding is included in the width calculation
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;